export default __webpack_public_path__ + "static/media/hook.7bf615ef.png";